module.exports = __webpack_public_path__ + "public/images/science.4a09610a5160b78c7e8c816721aec20a.png";